/**
 * Executes the function passed in at the interval specified.
 * Returns a promise when finished if the count is finite.
 */

export const DEFAULT_DELAY_TIME = 500;

class IntervalPromise {
  /**
   *
   * @param {Object} params
   * params.action - Must return a promise
   */
  constructor(params) {
    if (!params || !params.action) {
      throw new Error(`Invalid params: ${params}`);
    }
    this.timeBetweenIterations =
      params.timeBetweenIterations || DEFAULT_DELAY_TIME;
    this.stopCondition = params.stopCondition || this.executeForever;
    this.action = params.action;
    this.maxRetries = params.maxRetries || Infinity;
    this.retries = 0;
  }

  doUntilCondition() {
    return new Promise(this.waitForCondition.bind(this));
  }

  destroy() {
    this.stopCondition = this.stopExecution;
    this.action = () => {};
  }

  stopExecution() {
    return true;
  }

  executeForever() {
    return false;
  }

  waitForCondition(resolve, reject) {
    if (this.retries >= this.maxRetries) {
      return reject("REACHED_MAX_RETRIES");
    }
    if (this.stopCondition()) {
      return resolve();
    } else {
      this.retries++;
      (this.action() || Promise.resolve())
        .then(() => this.delay(this.timeBetweenIterations))
        .then(() => this.waitForCondition(resolve, reject))
        .catch(err => console.error(err));
    }
  }

  delay(interval) {
    return new Promise(resolve => {
      setTimeout(resolve, interval);
    });
  }
}

IntervalPromise.create = params => {
  return new IntervalPromise(params);
};

export default IntervalPromise;
